import './styles.scss';
import App from './App.vue';
import { APP_CONFIG } from './config';
import { vCatchAppLinks } from '@shared/directives/catchAppLinks';
import * as Sentry from '@sentry/vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { i18n } from '@shared/i18n';
import { router } from './router';
import { initTheme } from '@shared/composables/useTheme';

// Reine Browser-SPA: kein Capacitor, kein Capgo, keine Legacy-Auth-Migration aus
// @capacitor/preferences — es gibt keinen nativen Vorgaenger dieser App.
initTheme();

window.kgrDynamicConfig = {
    ...window.kgrDynamicConfig,
    apiHost: window.kgrDynamicConfig?.apiHost || window.location.origin,
    apiPath: window.kgrDynamicConfig?.apiPath || APP_CONFIG.apiPath,
    appVersion: window.kgrDynamicConfig?.appVersion || APP_CONFIG.appVersion,
    appId: APP_CONFIG.appId,
    appType: APP_CONFIG.appType as 'employee' | 'end_user',
    institutionType: APP_CONFIG.institutionType as 'kindergarten' | 'club',
    sentryDsn: window.kgrDynamicConfig?.sentryDsn ?? null,
    sentryEnvironment: APP_CONFIG.sentryEnvironment,
};

const app = createApp(App);

const { sentryDsn, sentryEnvironment } = window.kgrDynamicConfig;
if (sentryDsn && sentryEnvironment) {
    Sentry.init({
        app,
        dsn: sentryDsn,
        environment: sentryEnvironment,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 0.05,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.05,
        ignoreErrors: [/^Http failure response for (.*): 0 Unknown Error$/],
    });
    Sentry.setTag('runtime', 'webapp');
    Sentry.setTag('webAppId', APP_CONFIG.appId);
    Sentry.setTag('webAppVersion', window.kgrDynamicConfig.appVersion);
}

app.use(createPinia()).use(router).use(i18n).directive('catch-app-links', vCatchAppLinks);

// Erst nach der initialen Navigation mounten: der beforeEach-Guard wartet dort auf
// `loadLocale(...)`, der Katalog steht also vor dem ersten Render. Sonst rendert die Shell
// ihre `$t()`-Keys gegen einen leeren de-Katalog ("Not found key").
router
    .isReady()
    .catch((error) => console.error('[boot] initial navigation failed', error))
    .finally(() => app.mount('#app'));
